// import {BASE_URL} from "@/utils/config";
//
// export const getRegisteredUsers = async (axiosInstance, filters) => {
//     try {
//         const response = await axiosInstance.post(`${BASE_URL}/admin/user/get-registered-users`, filters);
//         return response.data;
//     } catch (error) {
//         console.log("(admin/userApi.js) Error while fetching registered users: ", error);
//     }
// }
//
// export const getLoggedInUsers = async (axiosInstance, filters) => {
//     try {
//         const response = await axiosInstance.post(`${BASE_URL}/admin/user/get-logged-in-users`, filters);
//         return response.data;
//     } catch (error) {
//         console.log("(admin/userApi.js) Error while fetching logged-in users: ", error);
//     }
// }


import {BASE_URL} from "@/utils/config";

export const getPaginatedUsers = async (axiosInstance, payload) => {
	try {
		const response = await axiosInstance.post(`${BASE_URL}/admin/users/query`, payload);
		return response.data;
	} catch (error) {
		console.error("(admin/userApi.js) Error fetching paginated users: ", error);
		throw error;
	}
};

export const exportBulkUsers = async (axiosInstance, payload) => {
	try {
		// Important: responseType 'blob' is required for downloading files via Axios
		const response = await axiosInstance.post(`${BASE_URL}/admin/users/export`, payload, {
			responseType: 'blob'
		});
		return response.data;
	} catch (error) {
		console.error("(admin/userApi.js) Error exporting users: ", error);
		throw error;
	}
};

export const sendBulkCommunicationApi = async (axiosPrivate, payload) => {
	const response = await axiosPrivate.post("/admin/users/bulk-communicate", payload);
	return response.data;
};

export const sendBulkWhatsAppApi = async (axiosInstance, payload) => {
	try {
		const response = await axiosInstance.post(`${BASE_URL}/admin/users/bulk-whatsapp`, payload);
		return response.data;
	} catch (error) {
		console.error("(admin/userApi.js) Error sending bulk whatsapp messages: ", error);
		throw error;
	}
};